import { createSlice } from "@reduxjs/toolkit";
import { CountArr, StatusArr } from "./WmsPhysicalStockCountAction";
const initialState = {
  HeadObj: {
    SheetNo: 0,
    Loc: "",
    LocName: "",
    Date: new Date(),
    ReferenceNo: "",
    A_DocStat: "ENTER",
    User: "",
    UserName: "",
    Count: "",
  },
  SummaryObj: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    DocNo: "",
  },
  CountingDetail: {
    sheetID: "0",
    locCode: "",
    locName: " ",
    binCode: " ",
    binName: " ",
    countTyp: " ",
    userCode: " ",
    countStatus: " ",
    date: new Date(),
  },
  FilterCounting:{
    v_Loc: "",
    AisleCode: [{ UId: "All", Name1: "All" }],
    AisleCSV: "All",
    LevelCode: [{ UId: "All", Name1: "All" }],
    LevelCSV: "All",
    v_countTyp: CountArr[0].UID,
    v_Status: StatusArr[0].id,
  }
  // Set_SliceWmsPhysicalStockCount_CountingDetail
  // const { CountingDetail } = WmsPhysicalStockCountRo();
  // let iSIDetailObj = {
  //   SheetId: CountingDetail.SheetNo,
  // };
};

const SliceWmsPhysicalStockCount = createSlice({
  name: "SliceWmsPhysicalStockCount",
  initialState: { value: initialState },

  reducers: {
    Set_SliceWmsPhysicalStockCount_HeadObj: (state, action) => {
      state.value.HeadObj = action.payload;
    },
    Set_SliceWmsPhysicalStockCount_HeadObj_Init: (state, action) => {
      state.value.HeadObj = initialState.HeadObj;
    },
    Set_SliceWmsPhysicalStockCount_CountingDetail: (state, action) => {
      state.value.CountingDetail = action.payload;
    },
    Set_SliceWmsPhysicalStockCount_FilterCounting: (state, action) => {
      state.value.FilterCounting = action.payload;
    },
    Set_SliceWmsPhysicalStockCount_CountingDetail_Init: (state, action) => {
      state.value.CountingDetail = initialState.CountingDetail;
    },

    Set_SliceWmsPhysicalStockCount_SummaryObj: (state, action) => {
      state.value.SummaryObj = action.payload;
    },
    SliceWmsPhysicalStockCount_Init: (state) => {
      state.value = initialState;
    },

    Set_SliceWmsPhysicalStockCount_HeadObj_New_Set: (state, action) => {
      state.value.HeadObj.SheetNo = action.payload.SheetNo;
      state.value.HeadObj.Loc = action.payload.Loc;
      state.value.HeadObj.Date = action.payload.Date;
      state.value.HeadObj.ReferenceNo = action.payload.ReferenceNo;
    },
    Set_SliceWmsPhysicalStockCount_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
    Set_SliceWmsPhysicalStockCount_HeadObject_SheetNo_A_DocStat: (
      state,
      action
    ) => {
      state.value.HeadObj.SheetNo = action.payload.SheetNo;
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
  },
});

export const {
  Set_SliceWmsPhysicalStockCount_HeadObj,
  Set_SliceWmsPhysicalStockCount_SummaryObj,
  Set_SliceWmsPhysicalStockCount_HeadObject_A_DocStat,
  Set_SliceWmsPhysicalStockCount_HeadObject_SheetNo_A_DocStat,
  SliceWmsPhysicalStockCount_Init,
  Set_SliceWmsPhysicalStockCount_HeadObj_Init,
  Set_SliceWmsPhysicalStockCount_HeadObj_New_Set,
  Set_SliceWmsPhysicalStockCount_CountingDetail_Init,
  Set_SliceWmsPhysicalStockCount_CountingDetail,
  Set_SliceWmsPhysicalStockCount_FilterCounting
} = SliceWmsPhysicalStockCount.actions;
export default SliceWmsPhysicalStockCount.reducer;
